import http from '@/api/http.ts'
import type { StrapiResponse } from '@/types/strapi.ts'
import type { Testimonial } from '@/types/testimonials.ts'

const testimonialPopulateParams = {
    populate: {
        author: {
            populate: {
                avatar: true,
            },
        },
        quote: {
            fields: ['topic', 'text'],
        },
    },
}

const getTestimonialsByApiUrl = async (apiUrl: string): Promise<StrapiResponse<Testimonial[]>> => {
    return (
        await http.get(apiUrl, {
            params: testimonialPopulateParams,
        })
    ).data
}

export const getParticipantTestimonials = async (): Promise<StrapiResponse<Testimonial[]>> => {
    return getTestimonialsByApiUrl('/participant-testimonials')
}

export const getOrganizerTestimonials = async (): Promise<StrapiResponse<Testimonial[]>> => {
    return getTestimonialsByApiUrl('/organizer-testimonials')
}

export const getTestimonials = async () => {
    const [participantTestimonials, organizerTestimonials] = await Promise.all([
        getParticipantTestimonials(),
        getOrganizerTestimonials(),
    ])

    return {
        participantTestimonials,
        organizerTestimonials,
    }
}
